import classNames from 'classnames';
import ListSkeleton from './ListSkeleton';
import TableSkeleton from './TableSkeleton';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  variant: 'list' | 'table';
  size?: number;
  columns?: number;
  rows?: number;
  'aria-label'?: string;
  height?: number;
}

function LoadingState({ variant, 'aria-label': aLabel, size, columns, rows, height }: Props) {
  const { t } = useTranslation();
  const ariaLabel = aLabel || t('LOADING_STATES.A11Y_LABEL');

  useEffect(() => {
    // Scroll container is the main element in the page layout
    const mainElement = document.querySelector('main');
    if (!mainElement) return;
    mainElement.classList.add('main__fixed');

    return () => {
      mainElement.classList.remove('main__fixed');
    };
  }, []);

  return (
    <div className={classNames('empty-loading-state', `empty-loading-state--${variant}`)} data-testid="loading-state">
      {variant === 'list' && <ListSkeleton isLoading aria-label={ariaLabel} size={size} height={height} />}

      {variant === 'table' && <TableSkeleton isLoading aria-label={ariaLabel} columns={columns} rows={rows} />}
    </div>
  );
}

export default LoadingState;
